import { NJModal, NJModalContent, NJButton, NJFormItem } from '@engie-group/fluid-design-system-react';
import { useState, useEffect } from 'react';
import './ModalRenameJobAd.css';

function ModalRenameJobAd({ isOpen, id, title, handleRename, handleCancel, isTemplate }) {

    const [name, setName] = useState('');

    useEffect(() => {
        setName(title);
    }, [title, isOpen]);

    return (
        <NJModal
            id="modalRename"
            isOpen={isOpen}
        >
            <NJModalContent
                footer={
                    <>
                        <NJButton
                            emphasis="bold"
                            variant="secondary"
                            label="Cancel"
                            onClick={handleCancel}
                        />
                        <NJButton
                            label="Rename"
                            icon="font_download"
                            iconClassName="material-icons-outlined"
                            disabled={!name}
                            onClick={() => { handleRename(id, name) }}
                        />
                    </>
                }
                icon="font_download"
                id="modalRename"
                onClose={handleCancel}
                title={isTemplate ? 'Rename the template' : 'Rename the Job Ad'}
            >
                <NJFormItem
                    className='dashboard-job-input-hide-label'
                    label="" // "Job description"
                    name="myInput"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    labelKind="static"
                />
            </NJModalContent>
        </NJModal>
    )
}

export default ModalRenameJobAd;
